import React from 'react';

import Input, { InputProps } from '../Input/Input';

const PasswordInput: React.FC<InputProps> = (props) => {
  const [show, setShow] = React.useState(false);
  return (
    <Input
      type={show ? 'text' : 'password'}
      IconRight={
        show ? '/assets/EyePasswordHide.svg' : '/assets/EyePassword.svg'
      }
      onClickRightIcon={() => setShow(!show)}
      {...props}
      itemScope
      itemType='https://schema.org/Thing'
    />
  );
};

export default PasswordInput;
